import React, {useState} from "react";
import { Outlet } from "react-router";
import LandingPage from "./LandingPageDashboard";
export default function LandingPageLayout(){
    return (
        <div style={{padding:"1%", background:"#FFFFFF",height:"92vh"}}>
            <Outlet />
        </div>
    )
}